import React from 'react';
import { Box, Container, Typography, Grid, Paper, Avatar, Divider } from '@mui/material';
import { RocketLaunch, Groups, Verified, Visibility } from '@mui/icons-material';
import PublicLayout from "../../layouts/PublicLayout";

export default function AboutUs() {
  return (
    <PublicLayout>
      <Box sx={{ bgcolor: '#fff', pt: 8, pb: 10 }}>
        <Container maxWidth="lg">
          {/* Header Section */}
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography variant="overline" fontWeight={700} sx={{ color: '#f6521a', letterSpacing: 2 }}>
              OUR STORY
            </Typography>
            <Typography variant="h3" fontWeight={800} sx={{ mt: 1, mb: 3 }}>
              Empowering Restaurants through <br />
              <span style={{ color: "#f6521a" }}>Smart Technology</span>
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 700, mx: 'auto', fontSize: 18 }}>
              TPOS is developed by ABNScripts Technologies Pvt. Ltd. to bridge the gap 
              between complex restaurant operations and seamless customer experiences.
            </Typography>
          </Box>

          {/* Mission & Vision Row */}
          <Grid container spacing={4} sx={{ mb: 10 }}>
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 4, height: '100%', bgcolor: '#f8fafc', borderRadius: 4, border: '1px solid #e2e8f0' }}>
                <Visibility sx={{ fontSize: 40, color: '#f6521a', mb: 2 }} />
                <Typography variant="h5" fontWeight={700} gutterBottom>Our Vision</Typography>
                <Typography variant="body2" color="text.secondary" lineHeight={1.8}>
                  To become the global standard for restaurant management, providing 
                  every food business—from small cafes to large chains—with the 
                  digital tools needed to thrive in a data-driven world.
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 4, height: '100%', bgcolor: '#f8fafc', borderRadius: 4, border: '1px solid #e2e8f0' }}>
                <RocketLaunch sx={{ fontSize: 40, color: '#f6521a', mb: 2 }} />
                <Typography variant="h5" fontWeight={700} gutterBottom>Our Mission</Typography>
                <Typography variant="body2" color="text.secondary" lineHeight={1.8}>
                  To simplify restaurant operations through automation, real-time 
                  analytics, and robust cloud infrastructure, allowing owners to 
                  focus on what they do best: serving great food.
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          {/* Core Values / Corporate Stats */}
          <Divider sx={{ mb: 8 }} />
          <Grid container spacing={4} textAlign="center">
            {[
              { label: "Founded", val: "2024", icon: <Verified color="primary" /> },
              { label: "Registered In", val: "Pune, India", icon: <Groups color="primary" /> },
              { label: "Compliance", val: "RBI & DPDP", icon: <Verified color="primary" /> },
              { label: "Uptime", val: "99.9%", icon: <RocketLaunch color="primary" /> }
            ].map((stat, i) => (
              <Grid item xs={6} md={3} key={i}>
                <Typography variant="h4" fontWeight={800} sx={{ color: '#333' }}>{stat.val}</Typography>
                <Typography variant="body2" fontWeight={600} color="text.secondary">{stat.label}</Typography>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </PublicLayout>
  );
}